import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useGrossSalesV2 } from "./hooks/useGrossSalesV2";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import Header from "../../../components/Header";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { Box } from "../../../../../shared/Box/Box";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "totalSalesReport.info.title",
  rows: [
    "totalSalesReport.info.clinicTotalSales",
    "totalSalesReport.info.providerTotalSales",
  ],
};

const TotalSalesV2 = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };

  const { data, isLoading } = useGrossSalesV2(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicGrossSales?.length;
  const isProviderDataEmpty = !isLoading && !data?.providerGrossSales?.length;

  const providerData = useMemo(
    () =>
      data?.providerGrossSales?.map((provider) => ({
        providerName: provider.provider_name,
        totalSales: provider.total_sales,
      })) || [],
    [data],
  );

  const clinicData = useMemo(
    () =>
      data?.clinicGrossSales?.map((clinic) => ({
        clinicName: clinic.clinic_name,
        totalSales: clinic.total_sales,
      })) || [],
    [data],
  );

  const _clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Total Sales Report V2"
        selectedClinic={selectedClinic}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getTotalSalesReportV2()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex flex-col gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Total Sales", accessor: "totalSales" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Total Sales", accessor: "totalSales" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default TotalSalesV2;
